import React from "react";

const ExclamationMarkIcon = () => {
  return (
    <svg
      width="51"
      height="52"
      viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.4804 0.730469C11.4152 0.730469 0 12.1457 0 26.2109C0 40.2761 11.4152 51.6913 25.4804 51.6913C39.5456 51.6913 50.9609 40.2761 50.9609 26.2109C50.9609 12.1457 39.5456 0.730469 25.4804 0.730469ZM28.0285 38.9511H22.9324V33.855H28.0285V38.9511ZM28.0285 28.7589H22.9324V13.4707H28.0285V28.7589Z"
        fill="#D4001C"
      />
    </svg>
  );
};

export default ExclamationMarkIcon;
